import { jsx as _jsx } from "react/jsx-runtime";
const Send = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0.25 5.89L7.12 8.89001L10.12 15.76L15.87 0.130005L0.25 5.89ZM2.93 6L13.06 2.23L7.39 7.91L2.93 6ZM10 13.07L8.09 8.61L13.77 2.94L10 13.07Z" }) })));
Send.iconName = "send";
Send.iconCategory = "Actions";
export default Send;
